import { EventStatusEnum, EventTypeEnum, EventUnion, RecurringTypeEnum } from '@/types/schema';

export const getIsRecurringSession = (recurringCategory?: RecurringTypeEnum | null) =>
  recurringCategory === RecurringTypeEnum.Recurring;

export const getIsRecurringSessionInstance = (recurringCategory?: RecurringTypeEnum | null) =>
  recurringCategory === RecurringTypeEnum.RecurringInstance;

export const getCanJoinEvent = (event: EventUnion) => {
  const { type, status } = event;

  const isEventJoinable =
    type &&
    [EventTypeEnum.Live, EventTypeEnum.External].includes(type) &&
    status &&
    [EventStatusEnum.Waiting, EventStatusEnum.Started].includes(status);

  const canUserJoinEvent =
    !Boolean(event?.registrationSettings) || event.isUserRegistered || event.isUserInstructor;

  return Boolean(isEventJoinable && canUserJoinEvent);
};
